var map = {
	"./4a75ebe9-10d2-4d12-a02e-44cf9c574709_rw_3840-Felicitas Ernst-FOTOGRAFIA.webp": "./src/img/brands/government/4a75ebe9-10d2-4d12-a02e-44cf9c574709_rw_3840-Felicitas Ernst-FOTOGRAFIA.webp",
	"./9d4b5480-d8a5-4322-96f7-eeb8cdeca43c_rw_1200-Felicitas Ernst-FOTOGRAFIA.webp": "./src/img/brands/government/9d4b5480-d8a5-4322-96f7-eeb8cdeca43c_rw_1200-Felicitas Ernst-FOTOGRAFIA.webp",
	"./c7f8d3cf-30ed-4100-bcf9-152ab0f7c126_rw_1200-Felicitas Ernst-FOTOGRAFIA.webp": "./src/img/brands/government/c7f8d3cf-30ed-4100-bcf9-152ab0f7c126_rw_1200-Felicitas Ernst-FOTOGRAFIA.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img/brands/government sync \\.(webp%7Cjpg%7Cjpeg%7Cpng)$";